import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getPostingsAsync, getPostingsByEstateIdAsync } from "./postingListApi";

// Thunks (using createAsyncThunk)
export const fetchPostingsThunk = createAsyncThunk(
  "postings/fetchPostings",
  async (_, { rejectWithValue }) => {
    try {
      const data = await getPostingsAsync();
      return data;
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);

export const fetchPostingsByEstateIdThunk = createAsyncThunk(
  "postings/fetchPostingsByEstateId",
  async (estateId, { rejectWithValue }) => {
    try {
      const data = await getPostingsByEstateIdAsync(estateId);
      return data;
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);

// Slice
const initialState = {
  items: [],
  status: "idle", // 'idle' | 'loading' | 'succeeded' | 'failed'
  error: null,
};

const postingListSlice = createSlice({
  name: "postingList",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // fetchPostingsThunk
      .addCase(fetchPostingsThunk.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchPostingsThunk.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.items = action.payload || [];
      })
      .addCase(fetchPostingsThunk.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || action.error;
      })

      // fetchPostingsByEstateIdThunk
      .addCase(fetchPostingsByEstateIdThunk.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchPostingsByEstateIdThunk.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.items = action.payload || [];
      })
      .addCase(fetchPostingsByEstateIdThunk.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || action.error;
      });
  },
});

export const postingListReducer = postingListSlice.reducer;

// Selector: returns postings as an array for backwards compatibility
const selectPostingList = (state) => state.postings.postings;
const selectPublishedPostings = (state) => {
  const postings = selectPostingList(state);
  return postings.items.filter((posting) => posting.published);
};

export const postingListSelectors = {
  selectPostingList,
  selectPublishedPostings,
};
